<div class="flex items-center justify-center">
  <button type="button" class="bg-white!" (click)="backToMap()" mat-stroked-button color="primary">
    <div class="flex items-center">
      <rma-icon glyph="arrow_upward" />
      <span>{{ 'marketReports.scroll-to-map' | transloco }}</span>
    </div>
  </button>
</div>
